import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import AddCircle from '@mui/icons-material/AddCircle';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Block from '@mui/icons-material/Block';
import Cancel from '@mui/icons-material/Cancel';
import CheckBoxOutlineBlankSharp from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharp from '@mui/icons-material/CheckBoxSharp';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import DeleteForever from '@mui/icons-material/DeleteForever';
import Edit from '@mui/icons-material/Edit';
import Email from '@mui/icons-material/Email';
import Error from '@mui/icons-material/Error';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FiberNew from '@mui/icons-material/FiberNew';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Home from '@mui/icons-material/Home';
import Info from '@mui/icons-material/Info';
import LocalLibrary from '@mui/icons-material/LocalLibrary';
import Lock from '@mui/icons-material/Lock';
import Notifications from '@mui/icons-material/Notifications';
import OpenInNew from '@mui/icons-material/OpenInNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Person from '@mui/icons-material/Person';
import PersonAddSharp from '@mui/icons-material/PersonAddSharp';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import Search from '@mui/icons-material/Search';
import Send from '@mui/icons-material/Send';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';
import Undo from '@mui/icons-material/Undo';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Warning from '@mui/icons-material/Warning';
import { blue } from '@cpg-its/ads.constants.colors';
import CpgLogo from './icons/CpgLogo';
import Excel from './icons/Excel';
const IconWrapper = styled(MuiGrid)({
    position: 'absolute',
    borderRadius: 10,
    background: 'purple',
    height: 11,
    width: 11,
    right: 4,
    top: -4,
    fontSize: 8,
    '& > div': {
        position: 'relative',
        bottom: 1,
    },
});
const iconSizes = {
    xxsmall: {
        height: '.625rem', width: '.625rem',
    },
    xsmall: {
        height: '.875rem', width: '.875rem',
    },
    small: {
        height: '1rem', width: '1rem',
    },
    default: {
        height: '1.25rem', width: '1.25rem',
    },
    large: {
        height: '1.5rem', width: '1.5rem',
    },
    xlarge: {
        height: '3.125rem', width: '3.125rem',
    },
};
export const IconComponent = ({ color = blue, count = null, icon = null, size = 'default', }) => {
    const iconSizeStyle = iconSizes[size];
    const iconStyle = {
        color, ...iconSizeStyle,
    };
    const countBubble = count ? (_jsx(IconWrapper, { children: _jsx(MuiGrid, { children: count > 9 ? '9+' : `${count}` }) })) : null;
    const iconProps = {
        style: iconStyle,
    };
    const getIcon = (desiredIcon) => {
        switch (desiredIcon) {
            case 'addCircle':
                return _jsx(AddCircle, { ...iconProps });
            case 'addPerson':
                return _jsx(PersonAddSharp, { ...iconProps });
            case 'arrowBackward':
                return _jsx(ArrowBack, { ...iconProps });
            case 'arrowForward':
                return _jsx(ArrowForward, { ...iconProps });
            case 'back':
                return _jsx(ChevronLeft, { ...iconProps });
            case 'block':
                return _jsx(Block, { ...iconProps });
            case 'cancel':
                return _jsx(Cancel, { ...iconProps });
            case 'checkBoxChecked':
                return _jsx(CheckBoxSharp, { ...iconProps });
            case 'checkBoxOutline':
                return _jsx(CheckBoxOutlineBlankSharp, { ...iconProps });
            case 'check':
                return _jsx(Check, { ...iconProps });
            case 'checkCircle':
                return _jsx(CheckCircle, { ...iconProps });
            case 'circle':
                return _jsx(FiberManualRecordIcon, { ...iconProps });
            case 'circleClose':
                return _jsx(HighlightOffIcon, { ...iconProps });
            case 'close':
                return _jsx(Close, { ...iconProps });
            case 'cpgLogo':
                return _jsx(CpgLogo, { ...iconProps });
            case 'delete':
                return _jsx(DeleteForever, { ...iconProps });
            case 'dropdown':
                return _jsx(ArrowDropDown, { ...iconProps });
            case 'dropup':
                return _jsx(ArrowDropUp, { ...iconProps });
            case 'edit':
                return _jsx(Edit, { ...iconProps });
            case 'email':
                return _jsx(Email, { ...iconProps });
            case 'error':
                return _jsx(Error, { ...iconProps });
            case 'excel':
                return _jsx(Excel, { ...iconProps });
            case 'exclamation':
                return _jsx(PriorityHigh, { ...iconProps });
            case 'expand':
                return _jsx(ExpandMore, { ...iconProps });
            case 'forward':
                return _jsx(ChevronRight, { ...iconProps });
            case 'home':
                return _jsx(Home, { ...iconProps });
            case 'less':
                return _jsx(ExpandLess, { ...iconProps });
            case 'lock':
                return _jsx(Lock, { ...iconProps });
            case 'new':
                return _jsx(FiberNew, { ...iconProps });
            case 'notifications':
                return (_jsxs(_Fragment, { children: [_jsx(Notifications, { ...iconProps }), countBubble] }));
            case 'openInNew':
                return _jsx(OpenInNew, { ...iconProps });
            case 'pdf':
                return _jsx(PictureAsPdfIcon, { ...iconProps });
            case 'person':
                return _jsx(Person, { ...iconProps });
            case 'published':
                return _jsx(LocalLibrary, { ...iconProps });
            case 'remove':
                return _jsx(RemoveCircle, { ...iconProps });
            case 'search':
                return _jsx(Search, { ...iconProps });
            case 'send':
                return _jsx(Send, { ...iconProps });
            case 'subdirectoryLeft':
                return _jsx(SubdirectoryArrowLeftIcon, { ...iconProps });
            case 'tooltip':
                return _jsx(Info, { ...iconProps });
            case 'undo':
                return _jsx(Undo, { ...iconProps });
            case 'visibility':
                return _jsx(Visibility, { ...iconProps });
            case 'visibilityOff':
                return _jsx(VisibilityOff, { ...iconProps });
            case 'warning':
                return _jsx(Warning, { ...iconProps });
            default:
                return null;
        }
    };
    return getIcon(icon);
};
export default IconComponent;
//# sourceMappingURL=icon.js.map